import React from "react";
import { CMR_TABLE_COLUMNS } from "../../../constants/translates";
import parseDate from "../../../helpers/date";
import { Cmr } from "../../../models/Cmr";
import { Column } from "../../common/Table/Interfaces";
import Actions from "./actions";
import DepartmentFilter from "../declarantTable/filters/selectColumns/department";
import SearchFilter from "../declarantTable/filters/searchFilter";
import DateFilter from "../declarantTable/filters/dateTimeFilter";

const COLUMNS = [
  {
    title: CMR_TABLE_COLUMNS.cmr_number,
    dataIndex: "cmr_number",
    key: "cmr_number",
    sorter: true,
    isActive: true,
    order: 1,
    width: 60,
    filterDropdown: SearchFilter,
  },
  {
    title: CMR_TABLE_COLUMNS.department,
    dataIndex: "department_id",
    key: "department_id",
    sorter: true,
    isActive: true,
    order: 2,
    width: 80,
    render: (test: unknown, record: Cmr) => record.department?.name || null,
    filterDropdown: DepartmentFilter,
  },
  {
    title: CMR_TABLE_COLUMNS.creator,
    dataIndex: "user",
    key: "user",
    sorter: true,
    isActive: true,
    order: 3,
    width: 80,
    render: (test: unknown, record: Cmr) => record.user?.nickname || null,
    filterDropdown: SearchFilter,
  },
  {
    title: CMR_TABLE_COLUMNS.cmr_date,
    dataIndex: "cmr_date",
    key: "cmr_date",
    sorter: true,
    isActive: true,
    order: 4,
    width: 80,
    render: (text, record: Cmr): string | null =>
      parseDate(record.cmr_date as string),
    filterDropdown: DateFilter,
  },
  {
    title: CMR_TABLE_COLUMNS.created_at,
    dataIndex: "created_at",
    key: "created_at",
    sorter: true,
    isActive: true,
    order: 5,
    width: 80,
    render: (text, record: Cmr): string | null => parseDate(record.created_at),
    filterDropdown: DateFilter,
  },
  {
    title: CMR_TABLE_COLUMNS.carrier,
    dataIndex: "carrier",
    key: "carrier",
    sorter: true,
    isActive: true,
    order: 6,
    width: 80,
    filterDropdown: SearchFilter,
  },
  {
    title: CMR_TABLE_COLUMNS.consignor,
    dataIndex: "consignor",
    key: "consignor",
    sorter: true,
    isActive: true,
    order: 7,
    width: 80,
    filterDropdown: SearchFilter,
  },
  {
    title: CMR_TABLE_COLUMNS.recipient,
    dataIndex: "consignee",
    key: "consignee",
    sorter: true,
    isActive: true,
    order: 8,
    width: 80,
    filterDropdown: SearchFilter,
  },
  {
    title: CMR_TABLE_COLUMNS.destination_customs,
    dataIndex: "destination_customs",
    key: "destination_customs",
    sorter: true,
    isActive: true,
    order: 9,
    width: 80,
    filterDropdown: SearchFilter,
  },
  {
    title: CMR_TABLE_COLUMNS.brutto,
    dataIndex: "brutto",
    key: "brutto",
    sorter: true,
    isActive: true,
    order: 10,
    width: 80,
    filterDropdown: SearchFilter,
  },
  {
    title: CMR_TABLE_COLUMNS.cll,
    dataIndex: "total",
    key: "total",
    sorter: true,
    isActive: true,
    order: 11,
    width: 80,
    filterDropdown: SearchFilter,
  },
  {
    title: CMR_TABLE_COLUMNS.invoice_number,
    dataIndex: "invoice",
    key: "invoice",
    sorter: true,
    isActive: true,
    order: 12,
    width: 80,
    filterDropdown: SearchFilter,
  },
  {
    title: CMR_TABLE_COLUMNS.actions,
    dataIndex: "actions",
    key: "actions",
    sorter: false,
    order: 9999,
    width: 120,
    ellipsis: true,
    isActive: true,
    render: (text, entity: Cmr) => <Actions entity={entity} />,
  },
] as Column[];

export default COLUMNS;
